import { Popper } from '@material-ui/core';
import React from 'react';

const AutoWidthPopper = (props) => {
    const { style: { width } } = props;
    const style = { minWidth: 'fit-content', width }
    return <Popper {...props} style={style}/>;
}

export default AutoWidthPopper;